export default __webpack_public_path__ + "static/media/fw-hailey-er-White Gold.75f7c698.mp4";